export default "__VITE_ASSET__lXFELuK9__"